<div class="relative inline-block text-left cursor-pointer w-full "  [ngClass]="dropdownWidthClass" #currentScope>
  <div (click)="toggleMenu(true, $event)" class="dropdown-button"   [ngClass]="dropdownToggleClass" >
    <ng-content select=".dropdown-button"></ng-content>
  </div>
  <div *ngIf="isOpen" class="absolute
  left-0 z-50 w-full md:w-auto
  rounded-md bg-card shadow-md shadow-card-hover">
    <div (click)="toggleMenu(false, $event)">
      <ng-content select=".dropdown-options"></ng-content>
    </div>
  </div>
</div>
